import { AutoComplete } from '@authentic/loyalty-pwa/components/Form';
import { LocationServiceContext } from '@authentic/loyalty-pwa/providers';
import { useContext, useState } from 'preact/hooks';
import { FunctionalComponent, h } from 'preact';
import styled from 'styled-components';

const Link = styled.a`
  font-family: 'Nunito Sans';
  font-size: 12px;
  line-height: 34px;
  letter-spacing: 0.02px;
  text-decoration-line: underline;
  color: #000000;
`;

interface LocationProps {
  name: string,
  callback: (data: any) => void,
  defaultLabelValue: string,
  onChangeCallback?: (wordToSearch: string) => void,
}

const resultAdapter = (items: any) =>
  items.map((item: any) => ({ ...item, labelValue: `${item.label}, ${item.state}` }));

export const Location: FunctionalComponent<LocationProps> = ({ name, onChangeCallback, callback, defaultLabelValue }) => {
  const locationService = useContext(LocationServiceContext);
  const [options, setOptions] = useState([]);
  const [showResults, setShowResults] = useState(false);

  const getSuggestions = async (word: string) => {
    if (onChangeCallback) {
      onChangeCallback(word);
    }
    if (word && locationService) {
      setShowResults(false);
      if (isNaN(+word)) {
        locationService
          .searchLocations({ query: word })
          .then((res: any) => {
            setOptions(resultAdapter(res.locations));
          })
          .finally(() => setShowResults(true));
      } else {
        locationService
          .searchLocations({ zip_code: +word })
          .then((res: any) => {
            setOptions(resultAdapter(res.locations));
          })
          .finally(() => setShowResults(true));
      }
    } else {
      setOptions([]);
    }
  };

  const onSelected = (item: any) => {
    setShowResults(false);
    callback(item);
  };

  return (
    <div>
      <AutoComplete
        placeHolder={'Enter State, City, or Zip Code'}
        options={options}
        showResults={showResults}
        requests={getSuggestions}
        keyValue="id"
        onClickFunction={onSelected}
        defaultLabelValue={defaultLabelValue}
        autoComplete={'chrome-off'}
      />
      <Link
        target="_blank"
        rel="noopener noreferrer"
        href="https://locations.deltaco.com/index.html"
      >
        See all locations
      </Link>
    </div>
  );
};
